import Component from './Inbox'

export default Component
